const TOKEN_KEY = 'games_access_token';

/** API do gateway (mesma origem que /play/retro/). */
export function profileApiUrl(path) {
  const rel = String(path || '').replace(/^\//, '');
  if (typeof window === 'undefined') return `/api/profile/${rel}`;
  return `${window.location.origin}/api/profile/${rel}`;
}

function authHeaders() {
  try {
    const token = sessionStorage.getItem(TOKEN_KEY);
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

async function profileFetch(path, init = {}) {
  const res = await fetch(profileApiUrl(path), {
    ...init,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(),
      ...(init.headers || {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || `Erro ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export async function fetchProfileControls() {
  return profileFetch('controls');
}

export async function pushProfileControlEntry(systemKey, padProfile, controls, lastPadProfile) {
  return profileFetch('controls', {
    method: 'PUT',
    body: JSON.stringify({
      systemKey,
      padProfile,
      controls,
      lastPadProfile,
    }),
  });
}

export async function pushProfileControlsBulk(controls, lastPadProfile) {
  return profileFetch('controls', {
    method: 'PUT',
    body: JSON.stringify({ controls, lastPadProfile }),
  });
}
